import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { laseaAuthService } from '../../services/laseaAuthService';
import { laseaUserService } from '../../services/laseaUserService';

export default function ClientHeader() {
  const navigate = useNavigate();
  const [clientName, setClientName] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadClientProfile();
  }, []);

  const loadClientProfile = async () => {
    try {
      const profile = await laseaUserService?.getCurrentUser();
      setClientName(profile?.fullName);
    } catch (err) {
      console.error('Failed to load client profile:', err);
    }
  };

  const handleSignOut = async () => {
    setLoading(true);
    try {
      await laseaAuthService?.signOut();
      navigate('/client-login');
    } catch (err) {
      console.error('Sign out failed:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <header className="bg-gray-900 shadow-md px-6 py-4 flex items-center justify-between">
      <div className="flex items-center">
        <h1 
          className="text-2xl font-bold text-white cursor-pointer hover:text-blue-400 transition"
          onClick={() => navigate('/client-dashboard')}
        >
          LaSea
        </h1>
      </div>
      
      <div className="flex items-center gap-4">
        <span className="text-gray-300">Welcome, {clientName || 'Client'}</span>
        <button
          onClick={handleSignOut}
          disabled={loading}
          className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition disabled:opacity-50"
        >
          {loading ? 'Signing out...' : 'Sign Out'}
        </button>
      </div>
    </header>
  );
}